/**
 * Version number is auto-generated during Build step in pipeline
 * (yarn set-version 1.2.3)
 */
import { getVersion } from "@shop-storefront/utils";
import { servicesEndpoints } from "~/utils/bff/endpoints.constants";

interface Version {
  version: string;
}

export function useVersion() {
  const logVersion = async () => {
    Log.info(LogArea.app, "Version Frontend", getVersion().version);

    const middlewareVersion = await getMiddlewareVersion();
    Log.info(LogArea.app, "Version Middleware", middlewareVersion?.version || "n/a");
  };

  const getMiddlewareVersion = async () => {
    try {
      const { data } = await useFetch<Version>(() => servicesEndpoints.version.version);
      return data.value;
    } catch (_) {
      return undefined;
    }
  };

  return {
    logVersion,
  };
}
